import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from '../assets/images/logo_s.png';
import logoAni from '../assets/images/logo.gif';
import background from '../assets/images/1.jpg';
import background1 from '../assets/images/homepage.jpg';
import auth_apis from "../apis/includes/auth_apis";
import loader from '../assets/images/loader.gif';
import { useLogout } from '../context/LogoutContext';
import { ToastContainer, toast } from 'react-toastify';

export default function Login() {
  const [email, setEmail] = useState();
  const [pass, setPass] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [is_loading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { isLoggingOut, setIsLoggingOut } = useLogout();

  useEffect(() => {
    if (isLoggingOut) {
      setIsLoading(true);
      setIsLoggingOut(false);
      setTimeout(() => {
        setIsLoading(false);
      }, 500); // Adjust the timeout duration as needed
    }
  }, [isLoggingOut, setIsLoggingOut]);

  const signIn = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    try {
      const payload = {
        username: email,
        password: pass
      };
      const res = (await auth_apis.login(payload)).data;
      toast('You have logged in successfully', {
        position: "top-right",
        autoClose: 5000,
        theme: "dark",
        type: "success",
      });
      let token = res.token.replace(/"/g, '');
      localStorage.setItem("user", JSON.stringify(res.user));
      localStorage.setItem("jwt", JSON.stringify(token));

      navigate("/dashboard");
    } catch (error) {
      toast('You entered credentials are incorrect! 🔑', {
        position: "top-right",
        autoClose: 5000,
        theme: "dark",
        type: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setError(null);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const ErrorAlert = ({ handleClose }) => {
    return (
      <div className="relative">
        <div
          id="alert-border-2"
          className="absolute inset-x-0 -top-16 flex items-center p-4 mb-4 text-red-800 border-t-4 border-red-300 bg-red-50 dark:text-red-400 dark:bg-gray-800 dark:border-red-800"
          role="alert"
        >
          <svg
            className="flex-shrink-0 w-4 h-4"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
          </svg>
          <div className="ms-3 text-sm font-medium">
            You entered credentials are incorrect! 🔑
          </div>
          <button
            onClick={handleClose}
            type="button"
            className="ms-auto -mx-1.5 -my-1.5 bg-red-50 text-red-500 rounded-lg focus:ring-2 focus:ring-red-400 p-1.5 hover:bg-red-200 inline-flex items-center justify-center h-8 w-8 dark:bg-gray-800 dark:text-red-400 dark:hover:bg-gray-700"
            aria-label="Close"
          >
            <span className="sr-only">Dismiss</span>
            <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
          </button>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="flex h-screen">
        <div className="flex flex-1 flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24 bg-cover bg-center" style={{ backgroundImage: `url(${background})` }}>
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <ToastContainer />
            {error && <ErrorAlert handleClose={handleClose} />}<br />
            <div>
              <div className="flex items-center justify-center">
                <img
                  className="w-28 h-28 sm:w-32 sm:h-32 md:w-40 md:h-40 lg:w-48 lg:h-48 xl:w-50 xl:h-50"
                  src={is_loading ? logo : logoAni}
                  alt="Sewanagala Ayurveda"
                />
              </div>

              <h2 className="mt-12 text-2xl font-bold tracking-tight" style={{ textAlign: 'center', color: '#444444' }}>
                Sign in to Get Started
              </h2>
            </div>

            <div className="mt-8">
              <div className="mt-6">
                <form className="space-y-6">
                  <div>
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium text-gray-700"
                    >
                      User Name
                    </label>
                    <div className="mt-1">
                      <input
                        onChange={(e) => setEmail(e.target.value)}
                        id="email"
                        name="email"
                        type="email"
                        autoComplete="email"
                        required
                        placeholder="Enter User Name"
                        className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                      />
                    </div>
                  </div>

                  <div className="space-y-1">
                    <label
                      htmlFor="password"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Password
                    </label>
                    <div className="relative mt-1">
                      <input
                        onChange={(e) => setPass(e.target.value)}
                        id="password"
                        name="password"
                        type={showPassword ? "text" : "password"}
                        autoComplete="current-password"
                        required
                        placeholder="Enter Password"
                        className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                      />
                      <button
                        type="button"
                        onClick={togglePasswordVisibility}
                        className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5"
                      >
                        {showPassword ? (
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye text-gray-500" viewBox="0 0 16 16">
                            <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                            <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                          </svg>
                        ) : (
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye-slash text-gray-500" viewBox="0 0 16 16">
                            <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z" />
                            <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829" />
                            <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z" />
                          </svg>
                        )}
                      </button>
                    </div>
                  </div>
                  <div>
                    <button
                      type="submit"
                      className={`flex w-full justify-center rounded-md border border-transparent py-2 px-4 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 ${(is_loading || !email || !pass)
                        ? 'bg-gray-500 hover:bg-gray-600 cursor-not-allowed'
                        : 'bg-[#0da538] hover:bg-[#0a7c2d]'
                        }`}
                      disabled={is_loading || !email || !pass}
                      onClick={signIn}
                    >
                      {is_loading ? "Loading..." : "Sign in"}
                    </button>
                    {is_loading && (
                      <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-15 backdrop-blur z-50">
                        <div role="status">
                          <img src={loader} className="w-[200px] h-[200px]" alt="" />
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="relative hidden w-0 flex-1 lg:block">
          <img
            className="absolute inset-0 h-full w-full object-cover"
            src={background1}
            alt=""
          />
        </div>
      </div>
    </>
  );
}
